// extracted by mini-css-extract-plugin
module.exports = {"h2":"styles_h2___q9Nc","button":"styles_button__8GfF9","readMore":"styles_readMore__TR_QQ","readLess":"styles_readLess__nMQIh","link":"styles_link__YmEFw"};